import {styled} from "@mui/material";

export const PreviewIconWrapper = styled('div')({
  fontSize: '18px',
  paddingLeft: 5,
});
export const TypeIconWrapper = styled('div')({
  fontSize: '18px',
});
